import { useInfiniteQuery } from "@tanstack/react-query";
import { getPeriodSummaries } from "../actions/get-period-summaries.action";

export const PERIOD_SUMMARIES_KEY = "period-summaries";

const DEFAULT_PAGE_SIZE = 12;

export const useInfinitePeriodSummariesQuery = (
  phoneNumber?: string,
  enabled = true,
  services = "voice,sms",
  pageSize = DEFAULT_PAGE_SIZE,
) => {
  return useInfiniteQuery({
    queryKey: [PERIOD_SUMMARIES_KEY, phoneNumber, services, pageSize],
    queryFn: ({ pageParam = 1 }) =>
      getPeriodSummaries({
        phoneNumber: phoneNumber!,
        page: pageParam,
        limit: pageSize,
        services,
      }),
    initialPageParam: 1,
    getNextPageParam: (lastPage) => {
      if (lastPage.page < lastPage.totalPages) {
        return lastPage.page + 1;
      }

      return undefined;
    },
    enabled: Boolean(phoneNumber) && enabled,
    staleTime: 30_000,
    retry: 1,
  });
};
